const QuestionType = {
  Radio: 'radio',
  Checkbox: 'checkbox',
  Spectrum: 'spectrum',
  Matrix: 'matrix',
  Text: 'text'
};

export default QuestionType;
